import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, MouseEvent, useCallback, useContext, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { MESSAGE_MODE } from 'src/constants/messageMode';
import { EditCellContext } from 'src/contexts/EditCellContext';
import useViewMessage from 'src/hooks/useViewMessage';
import { stopPropagation } from 'src/utils';

const MessageSubject: FC<GridCellProps> = (props) => {
  const [cellClick] = useContext(EditCellContext);
  const { displayValue } = useGridCellDisplayValue(props);

  // Use unified context for mode detection
  const { mode } = useViewMessage();

  // Determine click type based on current mode
  const clickType = useMemo(() => {
    switch (mode) {
      case MESSAGE_MODE.INBOX:
        return 'subject-inbox';
      case MESSAGE_MODE.OUTBOX:
        return 'subject-outbox';
      default:
        return 'subject';
    }
  }, [mode]);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      stopPropagation(e);

      cellClick?.({
        data: props.dataItem,
        type: clickType,
      });
    },
    [cellClick, props.dataItem, clickType]
  );

  const button = (
    <button
      onClick={handleClick}
      className="text-link cursor-pointer text-left w-full message-cell-hover-expand"
    >
      {displayValue}
    </button>
  );

  return (
    <GridCellBase {...props} className="!text-left" rowSelectionEnabled>
      {button}
    </GridCellBase>
  );
};

export default MessageSubject;
